import { render, staticRenderFns } from "./Rubrique.vue?vue&type=template&id=54663813&scoped=true"
import script from "./Rubrique.vue?vue&type=script&lang=js"
export * from "./Rubrique.vue?vue&type=script&lang=js"
import style0 from "./Rubrique.vue?vue&type=style&index=0&id=54663813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54663813",
  null
  
)

export default component.exports